export enum EndCondition {
  None = 0,
  RoastingTimeTarget = 1,
  DevelopmentTimeTarget = 2,
  DevelopmentTimePercentage = 3,
  BeanTemperatureTarget = 4,
  DrumTemperatureTarget = 5,
}

export const EndConditionString = {
  [EndCondition.None]: 'editprofileview.none',
  [EndCondition.RoastingTimeTarget]: 'editprofileview.roasttime',
  [EndCondition.DevelopmentTimeTarget]: 'editprofileview.devtime',
  [EndCondition.DevelopmentTimePercentage]: 'editprofileview.devtimepercent',
  [EndCondition.BeanTemperatureTarget]: 'editprofileview.beantempcondition',
  [EndCondition.DrumTemperatureTarget]: 'editprofileview.drumtempcondition',
}
